module.exports = import("https://eu-west-1a.online.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js");;